(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var forms = document.querySelectorAll('form[action="/contact"]');

    forms.forEach(function(form) {
      form.addEventListener('submit', function () {
        var enquiryTypeField = form.querySelector('#contact-subject');
        var hiddenSubjectField = form.querySelector('#contact-subject-hidden');
        var nameField = form.querySelector('[name="contact[name]"]');

        var enquiryType = enquiryTypeField ? enquiryTypeField.value : '';
        var customerName = nameField ? nameField.value.trim() : '';

        if (!enquiryType) enquiryType = 'General Enquiry';
        if (!customerName) customerName = 'Customer';

        if (hiddenSubjectField) {
          hiddenSubjectField.value = 'Website Enquiry - ' + enquiryType + ' - ' + customerName;
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
